import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { useApiWrapperWithErrorValidation } from 'shared/hooks/use-api-wrapper-with-error-validation'
import { RequestMethodsEnum } from 'shared/hooks/use-api-wrapper-with-error-validation/types'
import type { UseQueryClearOptions } from 'shared/types/tanstack-utility-types'
import { unsubscribeKeys } from '../api/key-factory'
import type { SubscriptionStateInterface } from '../types/subscription-state-interface'

interface UseDisplayUnsubscribeFromCampaignOptions extends UseQueryClearOptions<
  SubscriptionStateInterface,
  Error,
  SubscriptionStateInterface
> {
  messageId: string
}

export function useDisplayUnsubscribeFromCampaign({
  messageId,
  ...options
}: UseDisplayUnsubscribeFromCampaignOptions): UseQueryResult<SubscriptionStateInterface> {
  const { fetcher } = useApiWrapperWithErrorValidation<
    RequestMethodsEnum.get,
    SubscriptionStateInterface
  >({ method: RequestMethodsEnum.get })

  return useQuery({
    queryKey: unsubscribeKeys.subscriptionState(messageId),
    queryFn: async () => fetcher(`/api/mailing/subscription-state/${messageId}`),
    gcTime: Infinity,
    retry: false,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchOnReconnect: 'always',
    ...options,
  })
}
